/**
 * Created by ys on 2018/4/3.
 */
import router from './router'
import store from  './store'
try {
  //路由根据store缓存重载:管理界面
  store.state.sys.routers.forEach(item => {
    item.component = resolve => {
      require(['./components/manage/' + 'Layout' + '.vue'], resolve)
    },
      item.children.forEach(child => {
        child.component = resolve => {
          require(['./components/managePage/' + child.meta.local + '.vue'], resolve)
        }
        child.children.forEach(grandchild => {
          grandchild.component = resolve => {
            require(['./components/managePage/' + grandchild.meta.local + '.vue'], resolve)
          }
        })
      })
  })
//路由根据store缓存重载:大屏界面
  store.state.user.menuRouter.forEach(item => {
    item.component = resolve => {
      require(['./components/unit.vue'], resolve)
    };
    if (item.meta.id === 5010000) {//支队
      item.children.forEach(child => {
        child.component = resolve => {
          require(['./components/super/' + child.type.replace('super/', '') + '.vue'], resolve)
        }
      });
    } else {//单位
      item.children.forEach(child => {
        child.component = resolve => {
          require(['./components/unit/' + child.type.replace('unit/', '') + '.vue'], resolve)
        }
      });
    }
  })
  router.addRoutes(store.state.user.menuRouter);
  router.addRoutes(store.state.sys.routers);
} catch (e) {
  localStorage.clear();
  localStorage.removeItem("certification");
}


let resetPassword = store.state.user.resetPassword;
if (resetPassword == "1") {
  localStorage.clear();
  localStorage.removeItem("certification");
}

router.beforeEach((to, from, next) => {//访问路由前触发
  let loginAble = window.config.LOGIN_ABLE;
  let titleName = "";
  // if(store.state) {
  //   titleName = store.state.user.titleName || "";
  // }
  if(window.location.hostname.includes('iotperception') || window.location.href.includes('/IoTPerception')){
    titleName = '智慧消防物联态势感知平台';
  }else if(window.location.hostname.includes('agencymonitor') || window.location.href.includes('/agencyMonitor')){
    titleName = '智慧消防监控一体机';
  }else if(window.location.hostname.includes('elevator') || window.location.href.includes('/elevatorMonitor')){
    titleName = '电动自行车消防远程监控管理系统';
  }else if(window.location.hostname.includes('hostcontrol') || window.location.href.includes('/hostControl')){
    titleName = '消防主机控制'
  }else if(window.location.hostname.includes('maintain') || window.location.href.includes('/maint/index')){
    titleName = '智慧维保平台'
  }else if(window.location.hostname.includes('residence') || window.location.href.includes('/dataVisual')){
    titleName = '住宅小区消防远程监控管理服务平台'
  }else if(window.location.hostname.includes('zhymgc')){
    titleName = '扬名广场隐患巡查系统 '
  }else if(window.location.hostname.includes('zhjgswglj')){
    titleName = '珠海市机关事务管理局消防安全管理系统'
  }else if(window.location.hostname.includes('zhdhq')){
    titleName = '斗门大横琴5.0产业新空间'
  }else{
    if(store.state) {
      titleName = store.state.user.titleName || "";
    }
  }
  document.title = titleName ? titleName :to.path === '/faceRecognition' ? '人脸识别' : '欢迎登录';
  let urlInfo = window.location.href;
  let haveInfo = urlInfo.split("?");
  let regionName = getRegionName();
  if (to.path === '/faceRecognition' ||to.path === '/signOutThree' ||to.path === '/signOutTwo' ||to.path === '/signOut' || to.path === '/autoLogin' || to.path === '/hostControlAutoLogin' || to.path === '/gotoSuperIndex' || to.path === '/gotoHuiZhouDataVisual' || to.path ==='/gotoUnitViewer' || to.path ==='/gotoVideoViewer'|| to.path ==='/dataVisual' || (store.state.user.isMaintainAgency == 1 && to.name == 'unitMaintViewer')) {
    next();
  } else if (localStorage.getItem("certification")) { // 判断是否有token,已登录的情况
    if (to.matched.length === 0 && to.path !== '/') { //匹配前往的路由不存在
      alert("该账号尚未获取访问此路径的权限！");
      //清除缓存
      localStorage.clear();
      localStorage.removeItem("certification");
      loginAble ? next({path: '/login'}) : next({path: '/404'});
      // regionName === "zh" ? next({path: '/ZHlogin'}) : next({path: '/login'});
    }
    // if ((to.path === "/login" || to.path === "/ZHlogin") && haveInfo.length > 1) {
    if (to.path === "/login" && haveInfo.length > 1) {
      loginAble ? next() : next({path: '/404'});
    // } else if (to.path === "/login" || to.path === "/ZHlogin" || to.path === '/') {
    } else if (to.path === "/login" || to.path === '/') {
      if (store.state.user.menuRouter.length == 0) {//不存在大屏界面直接调管理界面
        next({path: '/main'});
      } else if (store.state.user.isEnterprise == 1) {//单位大屏
        next({path: '/unit'});
      } else if (store.state.user.isEnterprise == 0) {//支队大屏
        next({path: '/super'});
      }
    } else {
      next()
    }
  }
  //未登录
  else {
    if (loginAble) {
      if (to.path === '/login') {
        next() 
      }
      else {
        next('/login')
      }
    } else {
      if (to.path === '/404') {
        next();
      } else {
        next('/404')
      }
    }
  }
})
function getRegionName() {
  let urlInfo = window.location.href;
  let regionName = urlInfo.split(".")[0];
  regionName = regionName.split("\/");
  regionName = regionName[regionName.length-1];
  return regionName;
}



// WEBPACK FOOTER //
// ./src/login.js